import axios from 'axios';
import withUrl from '../utils/url/withUrl';

export default {
  get: () => axios.get(withUrl('stripe/price_info')),
  post: (params: any) => axios.post(withUrl('stripe/create_session'), params),
};
